import React from "react";
import RangeSlider from "./RangeSlider";

function pctDisplay(v) {
  return v === 0 ? "Any" : `${v}%+`;
}

export default function AlevelResultsFilterPanel({ filters, updateFilter }) {
  return (
    <div className="v2-filter-panel">
      <RangeSlider
        label="A* %"
        value={filters.alevelAstar}
        onChange={(v) => updateFilter("alevelAstar", v)}
        min={0}
        max={100}
        step={5}
        displayValue={pctDisplay(filters.alevelAstar)}
      />
      <RangeSlider
        label="A*-A %"
        value={filters.alevelAstarA}
        onChange={(v) => updateFilter("alevelAstarA", v)}
        min={0}
        max={100}
        step={5}
        displayValue={pctDisplay(filters.alevelAstarA)}
      />
      <RangeSlider
        label="AAB+ (facilitating) %"
        value={filters.alevelAAB}
        onChange={(v) => updateFilter("alevelAAB", v)}
        min={0}
        max={100}
        step={5}
        displayValue={pctDisplay(filters.alevelAAB)}
      />
      <RangeSlider
        label="APS per Entry"
        value={filters.alevelAPS}
        onChange={(v) => updateFilter("alevelAPS", v)}
        min={0}
        max={60}
        step={2}
        displayValue={filters.alevelAPS === 0 ? "Any" : `${filters.alevelAPS}+`}
      />
      <RangeSlider
        label="Value Added"
        value={filters.alevelValueAdded}
        onChange={(v) => updateFilter("alevelValueAdded", v)}
        min={-1}
        max={1}
        step={0.1}
        displayValue={filters.alevelValueAdded === -1 ? "Any" : filters.alevelValueAdded >= 0 ? `+${filters.alevelValueAdded.toFixed(1)}` : filters.alevelValueAdded.toFixed(1)}
      />
    </div>
  );
}
